import { create } from "zustand";
import { GbApiUserRightEnum, GbApiUserRights } from "../enums/GbApiUserRightEnum";

/** GB-API rights, loaded (or read from the 1h cache) at startup. Until then, and when the check fails, every right reads as denied. */
interface UserRightsState {
    rights: GbApiUserRights;
    isLoaded: boolean;

    setRights: (rights: GbApiUserRights) => void;
}

export const useUserRightsStore = create<UserRightsState>()((set) => ({
    rights: {},
    isLoaded: false,

    setRights: (rights) => set({ rights, isLoaded: true }),
}));

export const hasGbApiRight = (right: GbApiUserRightEnum): boolean => useUserRightsStore.getState().rights[right] === true;
